var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.name != 'search'),expression:"$route.name != 'search'"}]}),_c('div',{ref:"appContent",staticClass:"appContent",class:{whiteBg:_vm.isWhiteBg}},[_c('div',{staticClass:"main tuoyu",class:{
        vipMain: _vm.$route.name == 'detailVip',
        searchMain: _vm.$route.name == 'search',
      }},[_c('router-view')],1),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }